import { render, staticRenderFns } from "./ServicePartner.vue?vue&type=template&id=6d708f3a"
import script from "./ServicePartner.vue?vue&type=script&lang=ts"
export * from "./ServicePartner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports